const fetchData = (pageId: number): string => `
    {
        page(id: "${pageId}", idType: DATABASE_ID) {
          PostLoginPage {
            trainingTitle
            trainingInfo {
              title
              description
            }
            buttonLinkTraining {
              ... on Page {
                id
                uri
              }
            }
            buttonTextTraining
          }
        }
  }
`;
export default fetchData;
